import React from 'react';
import { useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';
import Local from '../Local/Local';
import { usePageTitle } from '../../hooks/usePageTitle';
import { useTranslate } from '../../hooks/useTranslate';
import { baseURLSelector } from '../../redux/reducers/app/params';
import { getCategoriesRoute, getProvidersRoute } from '../../utils/routes';
import { NAMESPACES } from '../../constants/namespaces';
import { BONUSES_NAV_ITEM } from '../../constants/navigation';
import {
  ROOT,
  BONUSES,
  GAME,
  CATEGORY_DETAIL,
  BONUS_HISTORY,
  CATEGORY_LIST,
  PROVIDER_LIST,
  PROVIDER_DETAIL,
} from '../../constants/routeTemplates';

export const ROOT_PAGE_TRANSLATION_KEY = 'Root page seo title';

export const useRootItem = () => {
  const translate = useTranslate(NAMESPACES.INITIAL);
  const title = translate(ROOT_PAGE_TRANSLATION_KEY);
  const link = useSelector(baseURLSelector);

  return {
    title,
    link,
    active: false,
    isExternal: true,
  };
};

export const useBreadcrumbs = (disabledRoutes) => {
  const rootItem = useRootItem();
  const { path } = useRouteMatch();
  const pageTitle = usePageTitle();

  if (disabledRoutes?.some((route) => route === path)) {
    return [];
  }

  switch (path) {
    case ROOT:
      return [{ ...rootItem, link: null, active: true }];
    case PROVIDER_LIST:
    case CATEGORY_LIST:
      return [rootItem, { link: null, active: true, title: pageTitle }];
    case GAME:
    case CATEGORY_DETAIL:
      return [
        rootItem,
        {
          link: getCategoriesRoute(),
          title: <Local namespace={NAMESPACES.NAV}>Categories</Local>,
        },
        { link: null, active: true, title: pageTitle },
      ];

    case PROVIDER_DETAIL:
      return [
        rootItem,
        {
          link: getProvidersRoute(),
          title: <Local namespace={NAMESPACES.NAV}>Providers</Local>,
        },
        { link: null, active: true, title: pageTitle },
      ];

    case BONUSES:
    case BONUS_HISTORY:
      return [
        rootItem,
        {
          link: null,
          active: true,
          title: (
            <Local namespace={NAMESPACES.NAV}>
              {BONUSES_NAV_ITEM.translationKey}
            </Local>
          ),
        },
      ];

    default:
      return [];
  }
};
